var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.params.platform === 'ingame')?_c('IngameLayout',[_c('router-view')],1):_c('WebLayout',[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }